export var defaultProps = {
    notFoundContent: 'Not Found',
    className: '',
    // 占位符
    placeholder: '请选择',
    onChange: function (value) { },
    onClear: function (deletionValue) { },
    clear: true,
    //是否禁用
    disabled: false,
    // 初始化未选中
    defaultValue: '',
    value: '',
    //使单选模式可搜索
    showSearch: false,
    onSearch: function (value) { },
    mode: 'single',
    // 筛选过滤器
    filterOption: function (inputValue, option) {
        return true;
    },
    size: 'normal',
};
export var optionDefaultProps = {
    selected: false,
    disabled: false,
    value: '',
    title: '',
    onItemClick: function (optionProps, e) { },
};
